<template>
  <div class="tool-box">
    <div class="home-promote">
      <div class="promote-left" @click="btncollection">
        <svg-icon icon-class="home1_promote"></svg-icon>
        <p class="promote-left-span">获客推广</p>
      </div>
      <div class="promote-right">
        <div class="promote-right-img" v-for="(item, index) in moduleList" :key="index">
          <div class="home-line" @click="checkUp(item)">
            <div class="icon-div">
              <svg-icon :icon-class="item.img"></svg-icon>
              <p class="promote-right-span">{{item.name}}</p>
            </div>
            <p class="line-icon"></p>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="home-promote home-promote1">-->
<!--      <div class="promote-left">-->
<!--        <svg-icon icon-class="home2_promote"></svg-icon>-->
<!--        <p class="promote-left-span">常用应用</p>-->
<!--      </div>-->
<!--      <div class="promote-right">-->
<!--        <div class="promote-right-img" v-for="(item, index) in applications" :key="index">-->
<!--          <div class="home-line" @click="checkUp(item)">-->
<!--            <div class="icon-div">-->
<!--              <svg-icon :icon-class="item.img"></svg-icon>-->
<!--              <p class="promote-right-span">{{item.name}}</p>-->
<!--            </div>-->
<!--            <p class="line-icon"></p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      moduleList: [
        {
          name: "获客文章",
          img: "home_promote1",
          path: "/moreArticles",
        },
        {
          name: "每日签到",
          img: "home_promote2",
          path: "/moreInviteType",
        },
        {
          name: "我的主页",
          img: "home_promote3",
          path: "/homePageB"
        },
        {
          name: "邀请好友",
          img: "home_promote4",
          path: '/inviteFriends'
        },
      ],
      applications: [
        {
          name: "产品筛选",
          img: "home2_promote1",
          path: "/activity",
        },
        {
          name: "信贷方案",
          img: "home2_promote2",
          path: "/activity",
        },
        {
          name: "我的订单",
          img: "home2_promote3",
          path: "/myOrder"
        },
        {
          name: "我的小店",
          img: "home2_promote4",
          path: '/littleShop'
        },
      ],
    }
  },
  methods: {
    btncollection() {
      this.$router.push('/collection')
    },
    checkUp(item) {
      var authFlag = localStorage.getItem("authFlag") || 0;
      var buyFlag = localStorage.getItem("buyFlag") || 0;
      if (localStorage.getItem("isLogin") == 1) {
        if (item.name == "个人日签") {
          if (authFlag == 0) {
            // Toast('未实名认证')
            Dialog.alert({
              message: "请前往，我的->其他服务，下进行实名认证",
            }).then(() => {
              // on close
            });
          }
          // else if (buyFlag == 0) {
          //   Dialog.alert({
          //     message: "没有权限，请先购买会员",
          //   }).then(() => {
          //     if (localStorage.getItem("buyFlag") == 1) {
          //       Toast('您已购买，请勿重复购买')
          //       return
          //     }
          //     let data = this.baseUrl + "/post/index.html#/";
          //     jspay(data);
          //   });
          // } 
          else {
            this.$router.push('/daySign')
          }
        } else if (item.name == "素材列表") {
          if (authFlag == 0) {
            // Toast('未实名认证')
            Dialog.alert({
              message: "请前往，我的->其他服务，下进行实名认证",
            }).then(() => {
              // on close
            });
          }
          // else if (buyFlag == 0) {
          //   Dialog.alert({
          //     message: "没有权限，请先购买会员",
          //   }).then(() => {
          //     if (localStorage.getItem("buyFlag") == 1) {
          //       Toast('您已购买，请勿重复购买')
          //       return
          //     }
          //     let data = this.baseUrl + "/article/#/";
          //     jspay(data);
          //   });
          // } 
          else {
            this.$router.push(item.path);
          }
        } else {
          this.$router.push(item.path);
        }
      } else {
        this.$router.push({ path: '/login', query: { isLogin: 1 } })
      }
    },
  }
}
</script>

<style lang="less" scoped>
.home-promote {
  width: 345px;
  height: 77px;
  margin: 21px auto 0 auto;
  display: flex;
  justify-content: space-between;
  // justify-items: center;
  background: url("../../assets/publicImg/con-bg.png") no-repeat 100%;
  background-size: 100% 100%;
  // border: 1px solid;
  .promote-left {
    width: 84px;
    position: relative;
    .promote-left-span {
      // width: 57.5px;
      width: 100%;
      text-align: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      font-weight: bold;
      font-family: PingFang SC;
      color: #ffffff;
    }
    .svg-icon {
      width: 84px;
      height: 76px;
    }
    //   border: 1px solid;
  }
  .promote-right {
    width: calc(345px - 84.09px);
    height: 77px;
    display: flex;
    justify-content: space-around;
    text-align: center;
    // align-items: center;
    // justify-items: center;
    font-weight: Medium;
    font-family: "PingFang SC";
    color: #333333;
    .promote-right-img {
      display: flex;
      justify-content: center;
      align-items: center;
      .svg-icon {
        width: 30px;
        height: 30px;
      }
    }
    .home-line {
      width: 64.5px;
      height: 50.5px;
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      .icon-div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    }
    .line-icon {
      width: 0.5px !important;
      height: 19.02px !important;
      margin-top: 11.675px;
      background: #ededed;
    }
    .promote-right-img:last-child > .home-line > p {
      display: none;
    }
    .promote-right-span {
      // padding-top: 5.5px;
      font-size: 11px;
    }
  }
}
.home-promote1{
  margin-top: 17px;
}
</style>